<template lang="pug">
  #question-builder
    BField
      WtLabel(
        slot="label"
        text="Question Type"
        required
      )
      .multiline-radio
        BRadio(
          name="formFieldType"
          v-model="formFieldType"
          size="is-small"
          native-value="radio"
        ) Radio buttons (only one possible answer)
        BRadio(
          name="formFieldType"
          v-model="formFieldType"
          size="is-small"
          native-value="checkbox"
        ) Checkboxes (multiple answers)
        BRadio(
          name="formFieldType"
          v-model="formFieldType"
          size="is-small"
          native-value="dropdown"
        ) Dropdown (only one possible answer, many choices)
        BRadio(
          name="formFieldType"
          v-model="formFieldType"
          size="is-small"
          native-value="text"
        ) Text field
        BRadio(
          name="formFieldType"
          v-model="formFieldType"
          size="is-small"
          native-value="range"
        ) Range

    BField(label-for="question")
      WtLabel(
        slot="label"
        text="Question Text"
        required
      )
      BInput#question(
        name="question"
        v-model="question"
        type="text"
        maxlength="120"
        placeholder="What's your favorite color?"
      )
    BField(label-for="description")
      WtLabel(
        slot="label"
        text="Description / text"
      )
      BInput#description(
        name="description"
        v-model="description"
        type="textarea"
        rows="2"
        maxlength="320"
      )
    .block(v-if="formFieldType === 'range'")
      BField(label-for="rangeStart")
        WtLabel(
          slot="label"
          text="Range min value"
          required
        )
        BInput#rangeStart(
          name="rangeStart"
          v-model="rangeStart"
          type="number"
        )
      BField(label-for="rangeEnd")
        WtLabel(
          slot="label"
          text="Range max value"
          required
        )
        BInput#rangeEnd(
          name="rangeEnd"
          v-model="rangeEnd"
          type="number"
          :min="rangeStart"
        )

    .block.mb-6(v-if="showOptions")
      BField(label-for="options")
        WtLabel(
          slot="label"
          text="Answer Options"
          tooltipText="Dropdowns, radio buttons, and checkboxes need options. Please enter each option on its own line after a double hashtag (##).  See example below: "
          required
        )
        BInput#options(
          name="options"
          v-model="fieldsString"
          type="textarea"
          rows="6"
        )
    BField
      WtLabel(
        slot="label"
        text="Schedule Questions"
      )
      .block
        .is-size-7.label-description Leave end date blank if you don't want question to expire.
        .is-flex.is-flex-wrap-wrap.mt-4
          BField.pr-4
            BDatepicker(
              placeholder="Start Date"
              icon="calendar-today"
              position="is-top-right"
              editable
              v-model="startDate"
              :min-date="startOfToday().dateObject"
              :datetime-formatter	="(date) => this.date(date, 'DATE_TIME_FORMAT').formatted"
              :events="startDatePickerEvents"
            )
          BField
            BDatepicker(
              placeholder="End Date"
              icon="calendar-today"
              position="is-top-left"
              editable
              v-model="endDate"
              :min-date="startDate"
              :datetime-formatter	="(date) => this.date(date, 'DATE_TIME_FORMAT').formatted"
              :events="endDatePickerEvents"
            )
    .is-flex.is-align-items-center
      BCheckbox(type="is-info" v-model="required" size="is-small")
        span.is-size-6 Required
    .is-flex.is-align-items-center.py-4
      BCheckbox(type="is-info" v-model="showAtRegistration" size="is-small")
        span.is-size-6 Show at registration?
    //- BField(label-for="points").mt-5
    //-   WtLabel(
    //-     slot="label"
    //-     text="Points for answering the question"
    //-     tooltip-text="Set to 0 to have no points associated with this question."
    //-   )
    //-   BInput#points(
    //-     name="points"
    //-     v-model="points"
    //-     type="number"
    //-     min="0"
    //-     placeholder="0"
    //-   )
    .px-5.py-3.card.mb-4(v-if="showPreview")
      .is-size-6.preview-header Question Preview
      .is-size-6.mt-5 {{question}}
      .is-size-7.has-text-grey.question-description(v-html="description")
      QuestionPreviewAnswerAdminSuper.mt-2(
        :type="formFieldType"
        :answers="fieldsString"
        :rangeStart="rangeStart"
        :rangeEnd="rangeEnd"
        :invertSliderColor="true"
      )
    .points-section(v-if="showPreview && !isCoreTier")
      hr.points-section-divider
      .is-flex.is-align-items-center
        BCheckbox(type="is-info" v-model="challengePoints" size="is-small")
          span.is-size-6 Earn challenge points for answering the question
      .block(v-if="challengePoints").mt-4
        BField(label-for="pointsAmount")
          WtLabel(
            slot="label"
            text="Amount of points to be earned"
            required
          )
          BInput#rangeStart(
            name="pointsAmount"
            v-model="pointsAmount"
            type="number"
          )
        BCheckbox(type="is-info" v-model="correctAnswer" size="is-small").mt-5.mb-4
          span.is-size-6.mb-4 Only earn challenge points if the correct answer is provided
        WtLabel(
          v-if="correctAnswer"
          slot="label"
          text="Please select the correct answer"
          required
        )
        QuestionAnswers(
          v-if="correctAnswer"
          :question="questionData"
          @onAnswer="collectCorrectAnswer($event)"
          :default-answer="convertAnswerToCorrectType(correctAnswerValue)"
        )
      hr.points-section-divider
    .buttons.is-justify-content-space-between
      WtButton(
        is-text
        color="lightgrey"
        size="medium"
        bold
        @click.native="$emit('cancel')"
        :disabled="processingDraft || processingQuestion"
      ) Cancel
      .buttons
        WtButton(
          v-if="data === null"
          color="primary"
          size="medium"
          bold
          :disabled="disableSave"
          :loading="processingDraft"
          @click.native="saveDraft()"
        ) Save Draft
        WtButton(
          color="primary"
          size="medium"
          bold
          :disabled="disableSave"
          :loading="processingQuestion"
          @click.native="saveQuestion()"
          v-if="data === null || createQuestionFromData"
        ) Save Question
        WtButton(
          v-else
          color="primary"
          size="medium"
          bold
          :disabled="disableSave || disableUpdate"
          :loading="processingQuestion"
          @click.native="updateQuestion()"
        ) {{updateText}}
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import QuestionPreviewAnswerAdminSuper from "./QuestionPreviewAnswerAdminSuper";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtButton from "@@/WtButton/WtButton";
import WtLabel from "@@/WtLabel/WtLabel";
import WtTile from "../WtTile/WtTile";
import QuestionAnswers from "@@/ProgramQuestions/QuestionAnswers";

export default {
  name: "QuestionBuilderAdminSuper",

  components: {
    WtTile,
    QuestionPreviewAnswerAdminSuper,
    WtButton,
    WtLabel,
    QuestionAnswers
  },

  mixins: [dateUtilityMixin],

  props: {
    data: {
      type: Object,
      required: false,
      // if no data is provided, then we're on Create Question mode
      default: null
    },
    createQuestionFromData: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      id: null,
      order: null,
      question: "",
      fieldName: "",
      description: "",
      required: false,
      showAtRegistration: false,
      category: "",
      formFieldType: "",
      // points: 0,
      startDate: null,
      endDate: null,
      fieldsObject: null,
      fieldsString: "##Small\n##Medium\n##Large\n##Extra Large\n##2x Large",
      rangeStart: "0",
      rangeEnd: "10",
      processingQuestion: false,
      processingDraft: false,
      challengePoints: false,
      pointsAmount: null,
      correctAnswer: false,
      correctAnswerValue: null
    };
  },

  computed: {
    ...mapGetters("program", ["isCoreTier"]),
    endDatePickerEvents() {
      return this.startDate ? [this.startDate] : null;
    },

    startDatePickerEvents() {
      return this.endDate ? [this.endDate] : null;
    },

    showOptions() {
      const validOptions = ["radio", "checkbox", "dropdown"];
      return validOptions.includes(this.formFieldType);
    },

    disableUpdate() {
      let pointsSettingsChanged = false;
      if (
        this.pointsAmount &&
        parseInt(this.pointsAmount) !== this.data.pointValue
      ) {
        pointsSettingsChanged = true;
      }
      if (
        this.correctAnswerValue &&
        this.correctAnswerValue !== this.data.correctAnswer
      ) {
        pointsSettingsChanged = true;
      }
      if (this.challengePoints === !this.data.pointValue) {
        pointsSettingsChanged = true;
      }
      if (this.correctAnswer === !this.data.correctAnswer) {
        pointsSettingsChanged = true;
      }

      return (
        this.id === this.data.id &&
        this.order === this.data.order &&
        this.fieldName === this.data.name &&
        this.question === this.data.question &&
        this.description === this.data.description &&
        this.required === this.data.required &&
        this.showAtRegistration === this.data.registration &&
        this.formFieldType === this.data.type &&
        this.category === this.data.category &&
        this.fieldsString === this.convertFieldsToString(this.data.fields) &&
        this.date(this.startDate, "DATE_TIME_FORMAT").formatted ===
          this.date(this.data.startDate, "DATE_TIME_FORMAT").formatted &&
        this.date(this.endDate, "DATE_TIME_FORMAT").formatted ===
          this.date(this.data.endDate, "DATE_TIME_FORMAT").formatted &&
        !pointsSettingsChanged
      );
    },

    showPreview() {
      let answerOptions =
        this.formFieldType === "text" || this.formFieldType === "range"
          ? true
          : this.fieldsString;
      if (this.formFieldType === "range" && !this.rangeQuestionValid) {
        return false;
      }
      return !!(this.formFieldType && this.question && answerOptions);
    },
    disableSave() {
      return (
        (this.challengePoints &&
          (this.pointsAmount === null || this.pointsAmount === "")) ||
        (this.correctAnswer && this.correctAnswerValue === null) ||
        this.processingDraft ||
        this.processingQuestion ||
        this.question.length < 3 ||
        this.formFieldType.length === 0 ||
        this.required === null ||
        (this.formFieldType === "range" && !this.rangeQuestionValid) ||
        (this.formFieldType !== "text" &&
          this.formFieldType !== "range" &&
          this.fieldsString.length === 0) ||
        (this.formFieldType === "range" && (!this.rangeStart || !this.rangeEnd))
      );
    },
    rangeQuestionValid() {
      if (!this.rangeStart || !this.rangeEnd) {
        return false;
      }
      return parseInt(this.rangeStart) <= parseInt(this.rangeEnd);
    },

    updateText() {
      if (this._.get(this.data, "draft", false)) {
        return "Update Draft";
      }
      return "Update Question";
    },

    questionData() {
      return {
        type: this.formFieldType,
        fields:
          this.formFieldType !== "text"
            ? this.formatFieldsForCorrectAnswerSelector(
                this.fieldsString,
                this.formFieldType
              )
            : undefined
      };
    }
  },

  mounted() {
    if (this.data !== null) {
      this.id = this.data.id;
      this.order = this.data.order;
      this.fieldName = this.data.name;
      this.question = this.data.question;
      this.description = this.data.description;
      this.required = this.data.required;
      this.showAtRegistration = this.data.registration;

      if (this.data.startDate !== "") {
        this.startDate = this.date(
          this.data.startDate,
          "DATE_TIME_FORMAT"
        ).dateObject;
      }
      if (this.data.endDate !== "") {
        this.endDate = this.date(
          this.data.endDate,
          "DATE_TIME_FORMAT"
        ).dateObject;
      }

      this.category = this.data.category;
      this.fieldsObject = this.data.fields;

      this.formFieldType = this.data.type;
      if (this.formFieldType === "range") {
        this.fieldsString = this.convertFieldsToString(this.data.fields.values);
        this.rangeStart = this.data.fields.range_start;
        this.rangeEnd = this.data.fields.range_end;
      } else {
        this.fieldsString = this.convertFieldsToString(this.data.fields);
      }

      if (this.data.pointValue) {
        this.challengePoints = true;
        this.pointsAmount = this.data.pointValue;
      }
      if (this.data.correctAnswer) {
        this.correctAnswer = true;
        this.correctAnswerValue = this.data.correctAnswer;
      }
    }
  },

  methods: {
    ...mapActions(["snackBar"]),
    ...mapActions("program", ["addProgramQuestion", "updateProgramQuestion"]),

    convertFieldsToString(fields) {
      let string = "";
      Object.keys(fields).forEach(value => {
        string = `${string}\n##${this._.upperFirst(value)}`;
      });
      return string.trim();
    },

    saveDraft() {
      const questionData = this.createQuestionObject(true);
      this.processingDraft = true;
      this.createQuestion(questionData);
    },

    saveQuestion() {
      const questionData = this.createQuestionObject();
      this.processingQuestion = true;
      this.createQuestion(questionData);
    },

    createQuestion(data) {
      this.addProgramQuestion(data).then(response => {
        this.processingDraft = false;
        this.processingQuestion = false;
        if (response) this.$emit("cancel");
      });
    },

    updateQuestion() {
      const questionData = this.createUpdateQuestionObject();
      questionData.questionId = this.id;
      this.processingQuestion = true;
      this.updateProgramQuestion(questionData).then(response => {
        this.processingQuestion = false;
        if (response) this.$emit("cancel");
      });
    },

    createUpdateQuestionObject() {
      let questionUpdate = { programId: this.$auth.user().programId };
      if (
        this.question.substring(0, 30) !== this.data.question.substring(0, 30)
      ) {
        questionUpdate = {
          ...questionUpdate,
          name: this.question.substring(0, 30)
        };
      }
      if (this.question !== this.data.question) {
        questionUpdate = { ...questionUpdate, question: this.question };
      }
      if (this.description !== this.data.description) {
        questionUpdate = { ...questionUpdate, description: this.description };
      }
      if (this.required !== this.data.required) {
        questionUpdate = { ...questionUpdate, required: this.required };
      }
      if (this.showAtRegistration !== this.data.registration) {
        questionUpdate = {
          ...questionUpdate,
          registration: this.showAtRegistration
        };
      }
      if (
        this.date(this.startDate, "DATE_TIME_FORMAT").formatted !==
        this.date(this.data.startDate, "DATE_TIME_FORMAT").formatted
      ) {
        questionUpdate = {
          ...questionUpdate,
          startDate:
            this.startDate === null
              ? ""
              : this.startDate
              ? this.date(this.startDate, "DATE_FORMAT_DB").formatted
              : undefined
        };
      }
      if (
        this.date(this.endDate, "DATE_TIME_FORMAT").formatted !==
        this.date(this.data.endDate, "DATE_TIME_FORMAT").formatted
      ) {
        questionUpdate = {
          ...questionUpdate,
          endDate:
            this.endDate === null
              ? ""
              : this.endDate
              ? this.date(this.endDate, "DATE_FORMAT_DB").formatted
              : undefined
        };
      }
      if (this.category !== this.data.category) {
        questionUpdate = { ...questionUpdate, category: this.category };
      }
      if (this.formFieldType !== this.data.type) {
        questionUpdate = { ...questionUpdate, type: this.formFieldType };
      }
      if (this.formFieldType === "range") {
        if (
          this.fieldsString !==
          this.convertFieldsToString(this.data.fields.values)
        ) {
          questionUpdate = {
            ...questionUpdate,
            fieldsData:
              this.formFieldType !== "text"
                ? this.formatFieldsToObject(this.fieldsString)
                : undefined
          };
        }
      } else {
        if (
          this.fieldsString !== this.convertFieldsToString(this.data.fields)
        ) {
          questionUpdate = {
            ...questionUpdate,
            fieldsData:
              this.formFieldType !== "text"
                ? this.formatFieldsToObject(this.fieldsString)
                : undefined
          };
        }
        this.fieldsString = this.convertFieldsToString(this.data.fields);
      }
      if (this.rangeStart !== this.data.range_start) {
        questionUpdate = {
          ...questionUpdate,
          rangeStart:
            this.formFieldType === "range" ? this.rangeStart : undefined
        };
      }
      if (this.rangeEnd !== this.data.range_end) {
        questionUpdate = {
          ...questionUpdate,
          rangeEnd: this.formFieldType === "range" ? this.rangeEnd : undefined
        };
      }
      let actualCorrectAnswerValue =
        this.challengePoints && this.correctAnswer
          ? this.correctAnswerValue
          : "null-answer";
      if (
        actualCorrectAnswerValue !== this.data.correctAnswer &&
        actualCorrectAnswerValue
      ) {
        questionUpdate = {
          ...questionUpdate,
          answer: actualCorrectAnswerValue
        };
      }

      let actualPointsAmount = this.challengePoints ? this.pointsAmount : 0;
      if (actualPointsAmount !== this.data.pointValue) {
        questionUpdate = { ...questionUpdate, pointValue: actualPointsAmount };
      }
      return questionUpdate;
    },

    createQuestionObject(isDraft = false) {
      return {
        name: this.question.substring(0, 30),
        question: this.question,
        description: this.description,
        required: this.required,
        registration: this.showAtRegistration,
        startDate: this.startDate
          ? this.date(this.startDate, "DATE_FORMAT_DB").formatted
          : undefined,
        endDate: this.endDate
          ? this.date(this.endDate, "DATE_FORMAT_DB").formatted
          : undefined,
        programId: this.$auth.user().programId,
        type: this.formFieldType,
        category: this.category,
        draft: isDraft,
        fieldsData:
          this.formFieldType !== "text"
            ? this.formatFieldsToObject(this.fieldsString)
            : undefined,
        rangeStart:
          this.formFieldType === "range" ? this.rangeStart : undefined,
        rangeEnd: this.formFieldType === "range" ? this.rangeEnd : undefined,
        pointValue: this.challengePoints ? parseInt(this.pointsAmount) : 0,
        answer:
          this.challengePoints && this.correctAnswer
            ? this.correctAnswerValue
            : "null-answer"
      };
    },

    formatFieldsToObject(string) {
      const fields = {};

      const items = string.split("\n##");
      items[0] = items[0].replace("##", "");

      for (let item of items) {
        const key = item.toLowerCase();
        fields[key] = item;
      }

      return fields;
    },

    collectCorrectAnswer(event) {
      this.correctAnswerValue = this._.isArray(event.answer)
        ? event.answer.join(",")
        : event.answer.toString();
    },

    formatFieldsForCorrectAnswerSelector(string, questionType) {
      if (questionType === "range") {
        return {
          range_start: this.rangeStart,
          range_end: this.rangeEnd
        };
      }
      return this.formatFieldsToObject(string);
    },

    convertAnswerToCorrectType(answerValue) {
      if (answerValue && this.formFieldType === "checkbox") {
        return answerValue.split(",");
      }
      return answerValue;
    }
  }
};
</script>

<style lang="sass" scoped>
#question-builder
  .outlined-box
    padding: 12px
    border: 1px solid $primary-dark
    border-radius: $radius
    .b-radio.radio
      margin-left: 0
      margin-right: 0
    .b-radio.radio:not(:last-child)
      margin-bottom: 10px
  .multiline-radio
    display: flex
    flex-direction: column
    .b-radio.radio
      margin: 8px 0
  .label-description
    color: $grey
    margin-top: -0.5em
  .card
    background-color: $grey-lighter
  .preview-header
    font-family: $family-sans-serif-bold
.question-description /deep/ a
  color: $primary
.points-section-divider
  background-color: $grey-lighter
</style>
